import { Component, OnInit } from "@angular/core";
import {
  RemoveStore,
  GetSessionStore,
  GetStore,
  RemoveALL,
  SetSessionStore,
  SetStore
} from "../services/comment";
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { HttpBaseService } from "../services/httpBase.service";
import api from "../api";
import { NzMessageService, NZ_NOTIFICATION_CONFIG, NzNotificationService } from "ng-zorro-antd";
import { EmailService, Global } from "../../webconfig";
import { NzMessageDataOptions } from "ng-zorro-antd/src/message/nz-message.definitions";
import { NotificationComponent } from '../components/notification/notification.component';
import { PostForm } from '../services/comment';
import { MD5 } from '../services/comment';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"]
})
export class HeaderComponent implements OnInit {
  logoUrl: string;
  userName: string;
  previewImage: string;
  name: string;
  showpwdSwitch: Boolean;
  logoutSwitch: Boolean;
  previewVisible: Boolean;
  pwdIsShow = false;
  pwdTitle = '修改密码'
  showHp = false;
  pwd: object;
  fileList: any;
  userData: any;
  imgUpload: any;
  userInfo: any;
  certificate: any;
  pwdStatus: string;
  pwdFooter: any;
  email: any; // 当前域邮箱配置
  mailConfig = { // 邮箱参数
    userId: '', //  测试数据 it@hyproca.com
    newMailCount: 0,
    errorCount: 0,
    mailHome: '' // 邮箱登录首页
  };
  interval: any;

  constructor(private http: HttpBaseService, private msg: NzMessageService, private router: Router,
    private notification: NzNotificationService) {
    this.imgUpload = api.imgUpload;
    this.fileList = [];
    this.previewImage = '';
    this.previewVisible = false;
    this.showpwdSwitch = false;
    this.logoutSwitch = false;
    this.pwd = {
      oldPassword: "",
      newPassword: "",
      newPassword2: ""
    };
  }
  ngOnInit() {
    this.getInit();
  }
  getInit() {
    this.userInfo = JSON.parse(GetStore("successLoginInfo"));
    this.pwdStatus = GetSessionStore('pwdStatus');
    switch (this.pwdStatus) {
      case 'M':
        this.pwdTitle = '密码已过期';
        this.showPwdModal(); //弹出修改密码窗
        break;

      case 'D':
        this.pwdTitle = '请修改初始密码';
        this.showPwdModal(); //弹出修改密码窗
        break;

      case 'S':
        this.pwdFooter = true;

        break;
    }

    this.userName = this.userInfo.userName;
    this.certificate = this.userInfo.certificate;
    this.name = "";
    let url = window.location.hostname;

    switch (url) {
      case "e.kabrita.com.cn":
        document.title = "木易网管理平台";
        this.logoUrl = "assets/images/au2/kbtlogo.png";
        break;
      default:
        this.logoUrl = "assets/images/au7/logo3.png";
        document.title = "木易网管理平台";
        break;
    }

    this.mailConfig.userId = this.mailConfig.userId || this.userInfo.email;  // 如果初始化没有设置

    if (this.mailConfig.userId) {
      // 获取对应域名邮箱
      let domin: Array<string> = this.mailConfig.userId.split('@');
      this.email = EmailService[domin[1].toLowerCase()];

      if (this.userInfo.email && this.email) {
        if (this.email.mailType === '163') {
          this.getNewMailTipBy163();
          this.interval = setInterval(() => {
            this.getNewMailTipBy163();
          }, Global.newMailLoop);
        } else {
          this.getNewMailTip();
          this.interval = setInterval(() => {
            this.getNewMailTip();
          }, Global.newMailLoop);
        }
      }
    } else {
      window.console.log('此账号没有对应邮箱');
    }
  }
  logout() {
    if (GetStore("userInfo")) {
      const userInfo = GetStore("userInfo")
      RemoveALL();
      SetStore("userInfo", userInfo);
    } else {
      RemoveALL();
    }
    window.location.href = "/";
  }
  showPwdModal() {
    this.pwdIsShow = true;
    this.pwd = {};
  }
  showHeadPortrait() {

    this.http
      .post(api.findById, {
        params: JSON.stringify({
          id: this.userInfo.userId
        })
      })
      .subscribe(res => {
        if (res.status === "S") {
          this.showHp = true;
          this.userData = res.data[0];
          if (this.userData.userHeadImgUrl !== '' && this.userData.userHeadImgUrl !== undefined) {
            this.fileList = [
              {
                uid: -1,
                name: 'xxx.png',
                status: 'done',
                url: this.userData.userHeadImgUrl,
              }];

          }


        } else {
          this.msg.warning(res.msg);
        }
      });

  }
  hpCancel() {

    this.showHp = false;
  }
  saveHp() {
    let fileList = this.fileList[0];
    if (fileList.uid === -1) {
      this.showHp = false;
    } else {
      this.userData.userHeadImgUrl = this.fileList[0].thumbUrl;
      this.userInfo.userHeadImgUrl = this.userData.userHeadImgUrl;
      SetStore("successLoginInfo", JSON.stringify(this.userInfo));
      this.http
        .post(api.userSave, {
          params: JSON.stringify(this.userData)
        })
        .subscribe(res => {
          if (res.status === "S") {
            this.showHp = false;
            this.userInfo.userHeadImgUrl = this.fileList[0].thumbUrl;
            this.msg.success(res.msg);
          } else {
            this.msg.warning(res.msg);
          }
        });
    }


  }
  mouseover(str) {

    switch (str) {
      case "showpwd":
        this.showpwdSwitch = true;
        break;
      default:
        this.logoutSwitch = true;
        break;
    }
  }
  mouseout(str) {
    switch (str) {
      case "showpwd":
        this.showpwdSwitch = false;
        break;
      default:
        this.logoutSwitch = false;
        break;
    }
  }
  savePwd() {
    if (!this.pwd["newPassword"] || !this.pwd["oldPassword"]) {
      this.msg.warning("请输入密码");
      return;
    }
    if (this.pwd["newPassword"] !== this.pwd["newPassword2"]) {
      this.msg.warning("两次密码输入不一致");
      return;
    }

    this.http
      .post(api.changePassword, {
        params: JSON.stringify({
          oldPassword: MD5(this.pwd["oldPassword"]),
          newPassword: MD5(this.pwd["newPassword"]),
          userId: this.userInfo.userId,
          userName: this.userInfo.userName
        })
      })
      .subscribe(res => {
        if (res.status === "S") {
          this.pwdIsShow = false;
          this.msg.success(res.msg);
          SetSessionStore('pwdStatus', res.status);
        } else {
          this.msg.warning(res.msg);

        }
      });
  }
  pwdCancel() {
    this.pwdIsShow = false;
  }
  home() {
    this.router.navigate(['main']);
  }
  beforeUpload = (file: File) => {
    const type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
    const isJPG = '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
    if (!isJPG) {
      this.msg.error('当前图片格式仅支持jpg|png|jpeg|bmp|gif格式！！');
    }
    const isLt2M = file.size / 1024 / 1024 < 1;
    if (!isLt2M) {
      this.msg.error('图片必于小于1MB!');
    }
    return isJPG && isLt2M;
  }
  handleChange({ file, fileList }) {
    const status = file.status;
    console.log(status);
    // removed删除
    // uploading添加
    if (file.response) {
      if (this.fileList.length && file.response.status === 'S') {
        this.fileList.map((key, value) => {
          if (this.fileList[value].thumbUrl === file.thumbUrl) {
            let response = file.response.data[0];
            this.fileList[value]['url'] = response.accessPath;
            this.fileList[value].thumbUrl = response.accessPath;
          }
        });
      } else {
        this.msg.success(file.response.msg);
        this.fileList = [];
      }
    }
    // if (status === 'done') {
    //  this.msg.success(`${file.name} file uploaded successfully.`);
    // } else if (status === 'error') {
    //  this.msg.error(`${file.name} file upload failed.`);
    // }
  }
  headImagechanger(evet) {
    console.log(event);
  }

  // 获取邮件提醒
  getNewMailTip() {

    // 获取QQ企业邮箱信息
    this.http.post(api.getNewMailByQQ, {
      params: JSON.stringify({
        corpsecret: this.email.newMailSecret,
        corpid: this.email.corpid,
        userId: this.mailConfig.userId
      })
    }, null, false)
      .subscribe(res => {
        let data = JSON.parse(res.data);

        if (data.errcode === 0) {
          if (data.count > 0 && data.count > this.mailConfig.newMailCount) {
            this.mailConfig.newMailCount = data.count;
            this.createBasicNotification();
          }
          this.mailConfig.newMailCount = data.count;
        } else if (data.errcode === 60111) {
          this.msg.error('当前邮箱用户不存在：' + data.errmsg);
          clearInterval(this.interval);
        }
      });
  }

  // 申请QQmail的 新邮件提醒 token
  getNewMailToken() {
    this.http.post(api.getTokenByQQ, {
      params: JSON.stringify({
        corpsecret: this.email.newMailSecret, corpid: this.email.corpid
      })
    })
      .toPromise()
      .then(result => {
        if (result.errcode === 0) {
          console.log('获取token成功');
          SetSessionStore('newMailToken', result.access_token);
        } else {
          if (this.mailConfig.errorCount >= 5) {
            clearInterval(this.interval);
          }
          this.mailConfig.errorCount++;
          window.console.log('获取新邮件提醒token 错误第 ' + this.mailConfig.errorCount + ' 次');
        }
      });

    // 前端获取token 跨域了，不能使用
    /* this.http.get(`${this.email.apiUrl}gettoken`, { corpsecret: this.email.newMailSecret, corpid: this.email.corpid })
      .toPromise()
      .then(result => {
        if (result.errcode === 0) {
          console.log('获取token成功');
          SetSessionStore('newMailToken', result.access_token);
        } else {
          if (this.mailConfig.errorCount >= 5) {
            clearInterval(this.interval);
          }
          this.mailConfig.errorCount++;
          window.console.log('获取新邮件提醒token 错误第 ' + this.mailConfig.errorCount + ' 次');
        }
      }); */
  }
  // 邮件提醒提示
  createBasicNotification(): void {
    this.notification.info('您有新邮件', `您当前有 (${this.mailConfig.newMailCount}) 封邮件未读`);
  }

  // 获取 邮箱一键登录地址
  getLoginMain(dom) {

    if (this.email.mailType === '163') {
      this.getLoginMainBy163(dom);
    } else {
      this.getLoginMainByQQ(dom);
    }

  }


  // QQ 企业邮箱登录
  getLoginMainByQQ(dom) {

    this.http.post(api.getTokenByQQ, {
      params: JSON.stringify({ corpsecret: this.email.SSOSecret, corpid: this.email.corpid })
    })
      .toPromise()
      .then(result => {
        let data = JSON.parse(result.data);

        if (data.errcode === 0) {
          console.log('获取token成功');
          SetSessionStore('loginMailToken', data.access_token);

          this.http.post(api.getLoginUrlByQQ, {
            params: JSON.stringify({
              token: data.access_token,
              userId: this.mailConfig.userId
            })
          })
            .toPromise()
            .then(res => {
              let data2 = JSON.parse(res.data);

              if (data2.errcode === 0) {
                this.mailConfig.mailHome = data2.login_url;
                dom.href = data2.login_url;
                dom.click();
              } else {
                this.msg.error('当前邮箱用户不存在：' + data2.errmsg);
              }
            });

        } else {
          this.msg.error('邮箱配置错误：' + result.errmsg);
        }
      });
  }

  // 获取163企业邮箱新邮件提醒
  getNewMailTipBy163() {

    let account = this.mailConfig.userId.split('@')[0];
    // 获取网易企业邮箱信息
    this.http.post(api.unreadMailBy163, { params: JSON.stringify({ accountName: account, type: 1 }) }, null, false)
      .subscribe(res => {
        if (res.status === 'FAIL') {
          if (this.mailConfig.errorCount >= 5) {
            clearInterval(this.interval);
          }
          this.mailConfig.errorCount++;
          window.console.log('获取新邮件提醒token 错误第 ' + this.mailConfig.errorCount + ' 次');
        } else {

          if (res.count > 0 && res.count > this.mailConfig.newMailCount) {
            this.mailConfig.newMailCount = res.count;
            this.createBasicNotification();
          }
          this.mailConfig.newMailCount = res.count;
        }
      });
  }

  // 获取163企业邮箱一键登录地址
  getLoginMainBy163(dom) {
    let timestamp = new Date().valueOf();
    let account = this.mailConfig.userId.split('@')[0];
    let rsa = account + this.email.domain + timestamp;

    this.http.post(api.RSA, { params: JSON.stringify({ src: rsa }) })
      .toPromise()
      .then(res => {
        if (res.status === 'S') {
          dom.href = `${this.email.SSOApi}?domain=${this.email.domain}&account_name=${account}&time=${timestamp}&enc=${res.data}`;
          dom.click();
        } else {
          this.msg.error('网易邮箱：获取签名失败');
        }


      });

  }

}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/header/header.component.ts